var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMigrationCard2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2873.87 2929.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#18174a;}.cls-13,.cls-14,.cls-3,.cls-7{fill:#fff;}.cls-4{fill:#91b3fa;}.cls-5{fill:#bdd0fb;}.cls-6{opacity:0.89;}.cls-7,.cls-8{opacity:0.6;}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:#2b69b3;}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:url(#linear-gradient-4);}.cls-13{opacity:0.8;}.cls-14{opacity:0.78;}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:url(#linear-gradient-6);}.cls-17{fill:url(#linear-gradient-7);}.cls-18{fill:url(#linear-gradient-8);}.cls-19{fill:url(#linear-gradient-9);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:url(#linear-gradient-11);}.cls-22{fill:url(#linear-gradient-12);}.cls-23{fill:url(#linear-gradient-13);}.cls-24{fill:url(#linear-gradient-14);}.cls-25{fill:url(#linear-gradient-15);}.cls-26{fill:url(#linear-gradient-16);}.cls-27{fill:url(#linear-gradient-17);}.cls-28{fill:url(#linear-gradient-18);}.cls-29{fill:url(#linear-gradient-19);}.cls-30{fill:url(#linear-gradient-20);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3051.82,
    y1: 2911.69,
    x2: 987.87,
    y2: 1105.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1119.07,
    y1: 824.08,
    x2: -392.66,
    y2: 3106.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2267.16,
    y1: 3017.71,
    x2: 2592.33,
    y2: 2640.29,
    gradientTransform: "translate(2622.77 -1066.61) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2776.06,
    y1: 2365.01,
    x2: 1814.55,
    y2: 3817.58,
    gradientTransform: "translate(2622.77 -1066.61) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2747.38,
    y1: 2406.63,
    x2: 2235.4,
    y2: 3266.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2008.87,
    y1: 3017.71,
    x2: 2334.03,
    y2: 2640.29,
    gradientTransform: "translate(2547.12 -883.97) rotate(45)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2517.77,
    y1: 2365.01,
    x2: 1556.26,
    y2: 3817.58,
    gradientTransform: "translate(2547.12 -883.97) rotate(45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1750.58,
    y1: 3017.71,
    x2: 2075.74,
    y2: 2640.29,
    gradientTransform: "translate(2471.47 -701.33) rotate(45)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2259.48,
    y1: 2365.01,
    x2: 1297.97,
    y2: 3817.58,
    gradientTransform: "translate(2471.47 -701.33) rotate(45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2230.8,
    y1: 2406.63,
    x2: 1718.81,
    y2: 3266.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1313.53,
    y1: 3062.11,
    x2: 1739.93,
    y2: 2567.19,
    gradientTransform: "translate(2320.34 -487.42) rotate(45)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1980.87,
    y1: 2206.21,
    x2: 720.01,
    y2: 4111.02,
    gradientTransform: "translate(2320.34 -487.42) rotate(45)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 13094.49,
    y1: 1350.53,
    x2: 12803.61,
    y2: 1516.56,
    gradientTransform: "matrix(-1, 0, 0, 1, 13644.41, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 13066.35,
    y1: 1391.93,
    x2: 14061.61,
    y2: 768.89,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 4840.96,
    y1: 1475.73,
    x2: 4844.34,
    y2: 1183.23,
    gradientTransform: "matrix(-1, 0, 0, 1, 5812.71, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 13300.3,
    y1: 514.34,
    x2: 12614.57,
    y2: 1175.79,
    gradientTransform: "matrix(-1, 0, 0, 1, 13644.41, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1084.65,
    y1: 1164.75,
    x2: 949.37,
    y2: 1407.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1020.71,
    y1: 1055.41,
    x2: 931.1,
    y2: 967.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -7312.11,
    y1: -535.5,
    x2: -7178.74,
    y2: -772.85,
    gradientTransform: "translate(5390.96 -4806.52) rotate(-56.92)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -7283.72,
    y1: -519.55,
    x2: -7150.35,
    y2: -756.9,
    gradientTransform: "translate(5390.96 -4806.52) rotate(-56.92)",
    xlinkHref: "#linear-gradient-13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2701.06,1973.78c-266.75,628.08-977.3,979.93-1593.48,885-100.27-15.45-375.15-61.45-618.52-278.49C20.56,2162.5-79.64,1335.19,298.29,752.15,573.36,327.81,1066.44,87.26,1535,99.3c100.92,2.59,487.69,18.56,827.59,298.84,49.93,41.16,160,139,259.28,294.18C2854.87,1056.74,2874.9,1564.46,2701.06,1973.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1198.51,371.3l1435.12,38a148.73,148.73,0,0,1,144.75,145.05l50.81,2083.48a109.68,109.68,0,0,1-110.56,112.34L1073,2736.51a104.12,104.12,0,0,1-103.21-106.86l55.49-2094.07A168.81,168.81,0,0,1,1198.51,371.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1314.44,2707h-.14l-184-7.25c-61.22-2.41-109.71-54.21-108.09-115.45l7.37-277.88a3.38,3.38,0,0,1,3.37-3.3h.1a3.39,3.39,0,0,1,3.29,3.48L1029,2584.42c-1.52,57.57,44,106.25,101.59,108.52l184,7.26a3.38,3.38,0,0,1-.13,6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1035.26,2223.77h-.09a3.39,3.39,0,0,1-3.3-3.48l1.2-45a3.38,3.38,0,0,1,3.37-3.29h.1a3.39,3.39,0,0,1,3.29,3.47l-1.19,45A3.39,3.39,0,0,1,1035.26,2223.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1203.37,354.55c195.27,31.77,867,131.82,1425.34,103.81a45.34,45.34,0,0,1,47.68,44.05l55.7,2092.88a52.18,52.18,0,0,1-50.45,53.56c-234.72,7.66-1201.24,35.7-1544.52-9.48a41.34,41.34,0,0,1-35.89-41.88L1146.47,402A49,49,0,0,1,1203.37,354.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1257.68,463.93c182.09,29.62,808.5,122.92,1329.14,96.81a42.27,42.27,0,0,1,44.46,41.07l51.94,1951.62a48.66,48.66,0,0,1-47,49.94c-218.87,7.15-1120.16,33.29-1440.27-8.83a38.56,38.56,0,0,1-33.47-39.06l42.19-2047.33A45.73,45.73,0,0,1,1257.68,463.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2012.59,109c-50.88-37.44-96-37.92-127.95-29.4a63.32,63.32,0,0,0-46.71,65.35l9.72,149.73,162.45,18.76S2112.38,182.4,2012.59,109Zm-74.8,118.6a40.62,40.62,0,1,1,41.68-39.53A40.62,40.62,0,0,1,1937.79,227.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1862.72,235.83a8,8,0,0,1-5.08-7L1856.09,205a8.07,8.07,0,1,1,16.1-1l1.55,23.85a8.07,8.07,0,0,1-7.53,8.57A8,8,0,0,1,1862.72,235.83Zm-3-46.73a8.07,8.07,0,0,1-5.08-7l-1.17-18.1A64.58,64.58,0,0,1,1901,97.5a125.93,125.93,0,0,1,61.58-.9,8.07,8.07,0,0,1-3.66,15.72,109.88,109.88,0,0,0-53.76.77A48.4,48.4,0,0,0,1869.53,163l1.17,18.1a8.07,8.07,0,0,1-11,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1622.86,385.29l2-75.09a45.83,45.83,0,0,1,48.6-44.54l517.27,31.45a44.59,44.59,0,0,1,41.85,43l2.41,72.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1648.63,366a8.05,8.05,0,0,1-5.08-7.71l.8-30.38a46.72,46.72,0,0,1,47.94-45.47l81.86,2.17a8.07,8.07,0,0,1-.44,16.14l-81.85-2.17a30.6,30.6,0,0,0-31.38,29.76l-.81,30.38a8.07,8.07,0,0,1-8.28,7.85A8.19,8.19,0,0,1,1648.63,366Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1461.36,353.51l905.36,24a66.94,66.94,0,0,1,64.46,57.25l.65,4.45a57.49,57.49,0,0,1-58.41,65.77l-928.84-24.61a37.38,37.38,0,0,1-36.28-40.15l3.1-41.52A48.8,48.8,0,0,1,1461.36,353.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2569.11,1337.16l-8-445.1a8.66,8.66,0,0,0-8.44-8.5L1261.49,849.4a8.67,8.67,0,0,0-8.88,9.07L1274.49,1318c.22,4.57,4,7.68,8.52,7.75l1277.32,20.42h.15c4.78,0,8.69-3.29,8.74-8.07A3.9,3.9,0,0,0,2569.11,1337.16Zm-25.21-436.5,1.64,91L1274.77,959.45,1270.36,867ZM1291.41,1309.09l-15.82-332.26,1270.27,32.23,5.78,320.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1363.77,1092.39l576.76,9.2a19,19,0,0,0,19.46-20.42l-.13-2.18a22.56,22.56,0,0,0-21.78-21l-574.81-8.89a19.78,19.78,0,0,0-20.11,20.2l0,2.16A21.14,21.14,0,0,0,1363.77,1092.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1944.49,1172l-579.9-9.71a20,20,0,0,0-20.29,20.54l0,2.2a21.47,21.47,0,0,0,20.78,21.31l581.88,10c11.51.2,20.3-9.1,19.62-20.75l-.13-2.22C1965.8,1181.71,1956,1172.14,1944.49,1172Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2420.26,1109.25c12.14.19,21-9.5,19.89-21.62s-11.88-22-24-22.23l-253.29-3.92a19.63,19.63,0,0,0-20.2,21.48,24.36,24.36,0,0,0,23.42,22.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2451.08,1202.68c-1.17-12.32-12-22.45-24.22-22.66l-255.56-4.27c-12.13-.21-21.25,9.56-20.37,21.83s11.47,22.45,23.65,22.66l256.45,4.41C2443.27,1224.86,2452.25,1215,2451.08,1202.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2506.58,644.07c-.12,12.63-10,22.86-22,22.84L1302,664.6a24.05,24.05,0,0,1-24-24.08v-2a23.9,23.9,0,0,1,24-23.95l1183,4.61c12,.05,21.68,10.33,21.55,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2505.61,743.69c-.12,12.62-10,22.86-22,22.89L1302,769.07A23.89,23.89,0,0,1,1278,745.14v-2a24,24,0,0,1,24-24l1182.11-.2c12,0,21.66,10.23,21.53,22.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1503.74,1699.81h-.46l-168.67-.68c-24.31-.1-44.47-16.72-46.89-38.66l-15.62-141.43a31.16,31.16,0,0,1,7.23-23.48,37.45,37.45,0,0,1,26-13h0c14.23-1,33.81-2.83,55.36-4.78,46.93-4.26,100.11-9.1,131.36-9.66h.69c22.36-.13,41.68,13.4,47.12,33.08,9,32.49,8.56,94,7.25,159.56C1546.69,1682.24,1527.28,1699.68,1503.74,1699.81Zm-197.38-203.53a23.6,23.6,0,0,0-16.45,8.09,17.47,17.47,0,0,0-4.13,13.16L1301.4,1659c1.66,15,16,26.34,33.26,26.41l168.67.68h.34c16.12-.09,29.41-11.5,29.69-25.58,1.29-64.48,1.74-124.91-6.76-155.63-3.76-13.59-18.48-23.63-34.29-23-30.75.56-86,5.58-130.36,9.6-21.64,2-41.31,3.75-55.59,4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1324.56,1510.38c35.42-2.62,112.38-10.87,148.9-11.53,15.48-.28,29.1,9,32.81,22.39,7.19,26,6.55,78,5.59,125.94-.28,14.36-13.41,25.9-29.51,25.84l-134.79-.54c-16.58-.07-30.4-11.29-32-26l-12.48-113C1301.76,1521.77,1311.43,1511.35,1324.56,1510.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1650.65,1552.13c-7.43-.14-11.94,5.63-10,12.81l15.66,58c1.94,7.19,9.61,13,17,13l849.87-4.76a13.22,13.22,0,0,0,13.16-13.6l-1-35.87a14.32,14.32,0,0,0-13.89-13.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1500.1,2073.86h-.47l-168.67-.67c-24.3-.1-44.46-16.72-46.88-38.66l-15.62-141.44a31.15,31.15,0,0,1,7.23-23.47,37.39,37.39,0,0,1,26-13h0c14.23-1,33.81-2.83,55.36-4.78,46.92-4.27,100.1-9.1,131.36-9.66h.69c22.36-.13,41.68,13.4,47.12,33.08,9,32.49,8.55,94,7.25,159.56C1543.05,2056.29,1523.63,2073.73,1500.1,2073.86Zm-197.38-203.53a23.58,23.58,0,0,0-16.45,8.09,17.47,17.47,0,0,0-4.13,13.16L1297.76,2033c1.65,15,16,26.35,33.26,26.42l168.67.67h.33c16.13-.09,29.42-11.51,29.7-25.58,1.29-64.49,1.73-124.91-6.76-155.63-3.76-13.6-18.48-23.63-34.29-23-30.76.55-86,5.57-130.37,9.6-21.63,2-41.3,3.75-55.58,4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1320.92,1884.43c35.41-2.62,112.38-10.87,148.9-11.53,15.47-.28,29.1,9,32.8,22.39,7.2,26,6.56,78,5.6,125.94-.29,14.36-13.41,25.9-29.52,25.83l-134.78-.54c-16.58-.06-30.4-11.29-32-26l-12.48-113C1298.12,1895.81,1307.79,1885.4,1320.92,1884.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1647,1926.18c-7.44-.14-11.94,5.63-10,12.81l15.66,58c1.93,7.18,9.61,13,17,13l849.87-4.76a13.22,13.22,0,0,0,13.16-13.59l-1-35.87a14.34,14.34,0,0,0-13.89-13.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1496.45,2447.91H1496l-168.67-.67c-24.31-.1-44.46-16.72-46.88-38.67l-15.63-141.43a31.19,31.19,0,0,1,7.24-23.47,37.36,37.36,0,0,1,26-13h0c14.22-1.05,33.81-2.83,55.36-4.79,46.92-4.26,100.1-9.09,131.36-9.66h.69c22.35-.12,41.67,13.4,47.12,33.08,9,32.5,8.55,94,7.25,159.57C1539.4,2430.34,1520,2447.78,1496.45,2447.91Zm-197.37-203.53a23.54,23.54,0,0,0-16.45,8.09,17.52,17.52,0,0,0-4.14,13.16l15.63,141.43c1.65,15,16,26.34,33.26,26.41l168.67.68h.33c16.13-.09,29.42-11.51,29.7-25.59,1.28-64.48,1.73-124.91-6.76-155.62-3.76-13.6-18.48-23.63-34.29-23-30.76.56-86,5.58-130.37,9.6-21.64,2-41.3,3.76-55.58,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1317.27,2258.47c35.42-2.62,112.38-10.87,148.91-11.53,15.47-.28,29.1,9,32.8,22.4,7.2,26,6.55,78,5.6,125.93-.29,14.37-13.41,25.9-29.52,25.84l-134.79-.54c-16.57-.07-30.4-11.29-32-26l-12.48-113C1294.47,2269.86,1304.14,2259.45,1317.27,2258.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1643.37,2300.22c-7.44-.13-11.94,5.63-10,12.82l15.65,58c1.94,7.18,9.61,13,17,13L2516,2379.3a13.2,13.2,0,0,0,13.15-13.6l-1-35.86a14.33,14.33,0,0,0-13.9-13.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1414.09,2058.81C1334.93,1796.66,1001.31,760.63,515.2,198.53c-34.71-40.14-108.56-27.7-114.48,24.74C366.39,527.51,227.38,1480.53,1374,2092.46,1396.08,2104.24,1421.28,2082.62,1414.09,2058.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1374.09,2060.71a7,7,0,0,0,5.35-11.53C1012.39,1614.7,812.17,1227.71,708.85,979.59,597,711.05,571.61,543.32,571.37,541.65a7,7,0,0,0-13.87,2c.25,1.68,25.92,171.15,138.41,441.29,103.7,249,304.61,637.4,672.82,1073.26A7,7,0,0,0,1374.09,2060.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M897.82,1964.74c19,8.67,40.73-4.91,41.5-25.79,4.27-115.26-13.17-442.24-312.85-704.87C373.41,1012.3,257.25,868,209.06,798.89c-10.2-14.62-33.13-7.76-33.61,10.05C170.11,1005.36,207.87,1650.7,897.82,1964.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M916,1943.42a6.77,6.77,0,0,1-6.22-4.11c-2-4.67-203.55-471-539.26-793.09a6.76,6.76,0,0,1,9.36-9.76c337.75,324,540.33,792.84,542.34,797.54a6.77,6.77,0,0,1-6.22,9.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2548.45,2765.8a42.39,42.39,0,0,1-42.28,42.23H220a42.38,42.38,0,0,1-42.27-42.23L158.75,1452c0-23.23,27.36-68.58,77.52-65.17L2470.52,1329a106.53,106.53,0,0,1,109.32,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2506.71,2725.28a40.12,40.12,0,0,1-40,40H275.18a40.12,40.12,0,0,1-40-40l-18-1192.66c2.11-71.77,65-97.57,103.18-96l2141.33-57.45a74.87,74.87,0,0,1,76.81,76.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.86,2156.2a3.38,3.38,0,0,1-3.38-3.33l-1.42-96.73a3.39,3.39,0,1,1,6.77-.09l1.42,96.72a3.4,3.4,0,0,1-3.34,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.38,1919.18a3.39,3.39,0,0,1-3.38-3.34l-5.44-370.44c.11-24.78,7.75-44.58,22.7-58.91,27.19-26.06,69.7-24.74,71.53-24.68l683.82-18.35a3.52,3.52,0,0,1,3.47,3.29,3.39,3.39,0,0,1-3.3,3.47l-684,18.35c-1.93-.1-41.71-1.28-66.84,22.8-13.57,13-20.51,31.18-20.61,54l5.43,370.38a3.38,3.38,0,0,1-3.33,3.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.65,
    y: 2759.65,
    width: 2695.25,
    height: 115.43,
    rx: 7.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1659.8,1841.52H542c-16.81,0-21.21-23.22-5.58-29.38l558.89-220.06a15.22,15.22,0,0,1,11.15,0l558.9,220.06C1681,1818.3,1676.6,1841.52,1659.8,1841.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 578.98,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 614.93,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 650.89,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "701.22 1850.1 552.61 1850.1 552.61 1856.55 574.18 1866.88 679.65 1866.88 701.22 1856.55 701.22 1850.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "702.42 2353.45 553.81 2353.45 553.81 2330.22 575.38 2319.89 680.85 2319.89 702.42 2330.22 702.42 2353.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 768.33,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 804.29,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 840.24,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "890.58 1850.1 741.97 1850.1 741.97 1856.55 763.54 1866.88 869.01 1866.88 890.58 1856.55 890.58 1850.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "891.78 2353.45 743.17 2353.45 743.17 2330.22 764.74 2319.89 870.2 2319.89 891.78 2330.22 891.78 2353.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 957.69,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 993.65,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1029.6,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1079.93 1850.1 931.33 1850.1 931.33 1856.55 952.9 1866.88 1058.36 1866.88 1079.93 1856.55 1079.93 1850.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1081.13 2353.45 932.52 2353.45 932.52 2330.22 954.1 2319.89 1059.56 2319.89 1081.13 2330.22 1081.13 2353.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1147.05,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1183,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1218.96,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1269.29 1850.1 1120.68 1850.1 1120.68 1856.55 1142.26 1866.88 1247.72 1866.88 1269.29 1856.55 1269.29 1850.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1270.49 2353.45 1121.88 2353.45 1121.88 2330.22 1143.45 2319.89 1248.92 2319.89 1270.49 2330.22 1270.49 2353.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1336.41,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1372.36,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1408.31,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1458.65 1850.1 1310.04 1850.1 1310.04 1856.55 1331.61 1866.88 1437.08 1866.88 1458.65 1856.55 1458.65 1850.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1459.85 2353.45 1311.24 2353.45 1311.24 2330.22 1332.81 2319.89 1438.28 2319.89 1459.85 2330.22 1459.85 2353.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1525.76,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1561.72,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1597.67,
    y: 1874.07,
    width: 23.97,
    height: 441.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1648.01 1850.1 1499.4 1850.1 1499.4 1856.55 1520.97 1866.88 1626.43 1866.88 1648.01 1856.55 1648.01 1850.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1649.2 2353.45 1500.6 2353.45 1500.6 2330.22 1522.17 2319.89 1627.63 2319.89 1649.2 2330.22 1649.2 2353.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 514.19,
    y: 2363.37,
    width: 1180.95,
    height: 25.73,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 456.11,
    y: 2401.97,
    width: 1289.6,
    height: 65.77,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1847.96,
    y: 1597.25,
    width: 537.61,
    height: 158.31,
    rx: 61.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1847.96,
    y: 1814.93,
    width: 537.61,
    height: 158.31,
    rx: 61.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1847.96,
    y: 2032.62,
    width: 537.61,
    height: 158.31,
    rx: 61.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 452.81,
    y: 2500.96,
    width: 1949.25,
    height: 158.31,
    rx: 61.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 2598.89,
    cy: 2632.67,
    r: 242.42,
    transform: "translate(-1100.38 2608.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 2598.89,
    cy: 2632.67,
    r: 234.36,
    transform: "translate(-1100.38 2608.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2405.64,2538.69a3.33,3.33,0,0,1-1.52-.36,3.38,3.38,0,0,1-1.5-4.54,218.82,218.82,0,0,1,196.27-120.85,221.46,221.46,0,0,1,39.64,3.57,3.38,3.38,0,1,1-1.21,6.65,215.4,215.4,0,0,0-38.43-3.45,212.08,212.08,0,0,0-190.23,117.12A3.38,3.38,0,0,1,2405.64,2538.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 2604,
    cy: 2637.77,
    r: 198.36,
    transform: "translate(-1102.49 2613.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2584.53,2785.23v-21.58c-22.49-.9-44.74-6.21-60.55-13.13a12.48,12.48,0,0,1-6.9-14.74l5.49-20.1a12.58,12.58,0,0,1,17.08-8.24c15.67,6.57,35,11.77,55.9,11.77,21.67,0,37.83-7.34,37.83-22.4,0-13.59-12.49-21.67-42.6-29.75-43-11.75-73.82-30.48-73.82-68.31,0-34.15,25-60.23,68.31-67.21V2510a12.57,12.57,0,0,1,12.57-12.57h12.68A12.57,12.57,0,0,1,2623.1,2510v19.38c20.81.83,36,4.39,48,8.62a12.51,12.51,0,0,1,7.82,15.1l-5,18.59a12.54,12.54,0,0,1-16.55,8.47,130.94,130.94,0,0,0-47.08-8.54c-25.71,0-33,10.64-33,20.19,0,11.76,15.43,19.84,48.84,30.12,47.75,14.32,67.58,34.15,67.58,69.78,0,32.68-24.24,62.06-71.25,69.41v24.15a12.57,12.57,0,0,1-12.57,12.58h-12.68A12.58,12.58,0,0,1,2584.53,2785.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 2340.6,
    cy: 2632.67,
    r: 242.42,
    transform: "translate(-1176.03 2426.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 2340.6,
    cy: 2632.67,
    r: 234.36,
    transform: "translate(-1176.03 2426.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2147.35,2538.69a3.33,3.33,0,0,1-1.52-.36,3.38,3.38,0,0,1-1.5-4.54,218.81,218.81,0,0,1,196.27-120.85,221.26,221.26,0,0,1,39.63,3.57,3.38,3.38,0,1,1-1.2,6.65,215.4,215.4,0,0,0-38.43-3.45,212.08,212.08,0,0,0-190.23,117.12A3.37,3.37,0,0,1,2147.35,2538.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 2345.71,
    cy: 2637.77,
    r: 198.36,
    transform: "translate(-1178.14 2431.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2326.24,2785.23v-21.58c-22.49-.9-44.75-6.21-60.55-13.13a12.48,12.48,0,0,1-6.9-14.74l5.48-20.1a12.59,12.59,0,0,1,17.08-8.24c15.68,6.57,35,11.77,55.91,11.77,21.67,0,37.83-7.34,37.83-22.4,0-13.59-12.49-21.67-42.6-29.75-43-11.75-73.82-30.48-73.82-68.31,0-34.15,25-60.23,68.31-67.21V2510a12.57,12.57,0,0,1,12.57-12.57h12.68a12.57,12.57,0,0,1,12.58,12.57v19.38c20.81.83,36,4.39,48,8.62a12.51,12.51,0,0,1,7.82,15.1l-5,18.59a12.55,12.55,0,0,1-16.56,8.47,130.84,130.84,0,0,0-47.07-8.54c-25.71,0-33,10.64-33,20.19,0,11.76,15.42,19.84,48.84,30.12,47.75,14.32,67.58,34.15,67.58,69.78,0,32.68-24.24,62.06-71.25,69.41v24.15a12.57,12.57,0,0,1-12.57,12.58h-12.68A12.58,12.58,0,0,1,2326.24,2785.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 2082.31,
    cy: 2632.67,
    r: 242.42,
    transform: "translate(-1251.68 2243.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 2082.31,
    cy: 2632.67,
    r: 234.36,
    transform: "translate(-1251.68 2243.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1889.06,2538.69a3.33,3.33,0,0,1-1.52-.36,3.38,3.38,0,0,1-1.5-4.54,218.81,218.81,0,0,1,196.27-120.85,221.35,221.35,0,0,1,39.63,3.57,3.38,3.38,0,0,1-1.21,6.65,215.29,215.29,0,0,0-38.42-3.45,212.08,212.08,0,0,0-190.23,117.12A3.39,3.39,0,0,1,1889.06,2538.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 2087.42,
    cy: 2637.77,
    r: 198.36,
    transform: "translate(-1253.8 2248.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2068,2785.23v-21.58c-22.5-.9-44.75-6.21-60.55-13.13a12.48,12.48,0,0,1-6.9-14.74l5.48-20.1a12.58,12.58,0,0,1,17.08-8.24c15.68,6.57,35,11.77,55.91,11.77,21.67,0,37.83-7.34,37.83-22.4,0-13.59-12.49-21.67-42.6-29.75-43-11.75-73.82-30.48-73.82-68.31,0-34.15,25-60.23,68.31-67.21V2510a12.57,12.57,0,0,1,12.57-12.57h12.68a12.57,12.57,0,0,1,12.57,12.57v19.38c20.82.83,36,4.39,48,8.62a12.51,12.51,0,0,1,7.82,15.1l-5,18.59a12.55,12.55,0,0,1-16.56,8.47,130.84,130.84,0,0,0-47.07-8.54c-25.71,0-33,10.64-33,20.19,0,11.76,15.42,19.84,48.84,30.12,47.75,14.32,67.58,34.15,67.58,69.78,0,32.68-24.24,62.06-71.25,69.41v24.15a12.57,12.57,0,0,1-12.57,12.58h-12.69A12.57,12.57,0,0,1,2068,2785.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 1748.54,
    cy: 2557.19,
    r: 317.89,
    transform: "translate(-1296.07 1985.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 1748.54,
    cy: 2557.19,
    r: 307.32,
    transform: "translate(-1296.07 1985.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1495.12,2432.91a3.46,3.46,0,0,1-1.52-.36,3.39,3.39,0,0,1-1.49-4.54c49.16-97.4,147.42-157.9,256.43-157.9a289.74,289.74,0,0,1,51.79,4.66,3.39,3.39,0,0,1,2.72,3.94,3.35,3.35,0,0,1-3.94,2.71,283.49,283.49,0,0,0-50.57-4.54c-106.45,0-202.39,59.07-250.39,154.17A3.39,3.39,0,0,1,1495.12,2432.91Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 1755.24,
    cy: 2563.89,
    r: 260.11,
    transform: "translate(-1298.84 1992.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1729.71,2757.26V2729c-29.5-1.18-58.68-8.15-79.4-17.22a16.38,16.38,0,0,1-9-19.34l7.19-26.36a16.5,16.5,0,0,1,22.4-10.79c20.56,8.62,45.94,15.43,73.31,15.43,28.42,0,49.61-9.63,49.61-29.37,0-17.82-16.38-28.42-55.87-39-56.34-15.41-96.8-40-96.8-89.58,0-44.79,32.75-79,89.58-88.13v-28.31a16.48,16.48,0,0,1,16.49-16.48h16.62a16.48,16.48,0,0,1,16.49,16.48v25.42c27.3,1.09,47.17,5.76,62.94,11.3a16.4,16.4,0,0,1,10.25,19.8l-6.61,24.38a16.44,16.44,0,0,1-21.7,11.11,171.71,171.71,0,0,0-61.73-11.21c-33.72,0-43.35,14-43.35,26.49,0,15.41,20.23,26,64.05,39.49,62.61,18.78,88.62,44.79,88.62,91.5,0,42.87-31.79,81.39-93.43,91v31.67a16.49,16.49,0,0,1-16.49,16.49H1746.2A16.5,16.5,0,0,1,1729.71,2757.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M594.14,1621.2c.35-.13,184.85-323.25,209.78-353.65a19.34,19.34,0,0,1,17.26-6.94l51.5,6.14,60.49,130.88-100.79-58.7c10,69-119.5,171.48-163.91,208.89a10.2,10.2,0,0,0-.8,14.85l17.72,18.56c-29.1,29.5-62.69,48.45-100.59,57.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M675.14,1571.22s11.31,3.65,15.15,13.73a11.53,11.53,0,0,1-4.34,13.28c-18.63,13.35-80.09,56.45-108.45,64.88a3.2,3.2,0,0,1-4-3.78c1.46-6.58,6.16-19.74,21.33-39l-1.36,2.75a3.94,3.94,0,0,0,5.45,5.2C617.88,1617.58,656.52,1594.14,675.14,1571.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M666,1700.5c.31-.2,28-66.89,28.3-67.09,25.38-154.53,87.3-286.87,105.57-321.7a19.32,19.32,0,0,1,15.49-10.28L867,1297,952.78,1413,842.2,1375.86C865.92,1441.39,759.87,1568,724,1613.6a10.2,10.2,0,0,0,2.22,14.71l21.11,14.58c-22.53,34.78-51.58,60.13-86.93,76.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M735.21,1635.16s11.82,1.29,17.61,10.38a11.51,11.51,0,0,1-1.55,13.89c-15.55,16.84-67,71.48-93.07,85.49a3.21,3.21,0,0,1-4.7-2.89c.09-6.75,2-20.59,13-42.52l-.78,3a3.94,3.94,0,0,0,6.39,4C688.52,1692.15,721.62,1661.38,735.21,1635.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1108.93,1272.6s46.74,69.53,50.58,101.25-12.93,42.68-61.85,46.73c-145.61,12-217.38-31.61-217.38-31.61-10-63.5-17-79.66-100.23-114.19,0,0,105.21,8.36,126.39.14S1108.93,1272.6,1108.93,1272.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M906.29,965.08c-26.53-.22-54.13,6.74-65.44-9.08-16.63-23.26,8.68-86.44,51.1-102.89,44.28-17.17,75.08,29,122.4,12.1,37-13.24,34.12-47.15,68.58-72.74,57.17-42.45,171.23-28,213.89,28.56,69.72,92.46-50,299.33-140.67,301.82C1075.7,1125.07,1030.87,966.11,906.29,965.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M982.51,1263.4s-54.44-51.84-81.24-86.17a72.86,72.86,0,0,1-12.33-65.56c12.23-41.21,34-83.9,36-90.55,3-10.18,64.07-9.76,64.07-9.76s120.11,77.95,167.31,210l-53,16.5s-31.36-52.61-62.35-86.06c0,0,53.62,70.83,55.5,99.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M878.79,1283.85l40.9-44.5,47.24,12.72s55.07,8.53,86.59,0l31.52-8.53,71.24-22.18,11.18,31.62a19,19,0,0,1-7,21.87c-6.16,4.38-13.39,9.19-18,11.2-9.38,4.11-216.09,1.3-216.09,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M947,938l41,76.29c-2.71,16.65-44.65,17.12-51.13,7.18a9.79,9.79,0,0,1-1.29-3.37l-24.54-51c-1.05-5,12.57-21.72,17.06-24.1l16.3-8.68C950.73,931,924.53,930.71,947,938Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M864,920.07s-4.63,25.77,15.63,58.54,40.43,31.29,50.67,19.61,22.53-31.15,16.94-63.84S871,887.21,864,920.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M922.72,937.94s-32.8-43.09-58-5.53l.42,13s-18.82,10.37-15.27-19.81,16.36-62.7,53.42-52.39S962,895.24,966.22,921s-16.83,21.53-16.83,21.53-8-17.76-17.71-19-6.19,12.83-6.19,12.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M930.25,936.79s-17-22-1.53-26.63,14.89,21.61,13.88,31.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1014.18,1301.47h-.43l-188.14-.21a8.42,8.42,0,0,1,0-16.84l188.14.2a8.43,8.43,0,0,1,.41,16.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M656.48,1130.65H813.17a29.86,29.86,0,0,1,27,17.12l72.43,153.59H717.9A18.15,18.15,0,0,1,701,1289.89l-56.17-142.13A12.51,12.51,0,0,1,656.48,1130.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M766.87,1209.4c3.39,10.55.89,20.79-5.6,22.88s-14.51-4.77-17.9-15.32-.89-20.79,5.6-22.88S763.47,1198.85,766.87,1209.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1066.28,942.05l-1.5,0c-19.57-.59-39.65-10.09-61.39-29-33.85-29.51-46.75-34.36-73.5-34.36l-2.37,0v-1.09h2.24c26.76,0,40.44,5.06,74.34,34.62,21.55,18.78,41.4,28.19,60.71,28.77,20.82.61,42.52-12.17,59.46-35.11,7.38-10,13.56-21.08,19.54-31.79,5.6-10,11.39-20.41,18.17-29.92,5-6.93,12.77-16.75,23.62-22s23.11-4.75,31.34,1.28l-.64.88c-7.91-5.8-19.77-6.26-30.22-1.18-10.63,5.17-18.34,14.85-23.21,21.69-6.75,9.46-12.53,19.81-18.11,29.82-6,10.73-12.19,21.83-19.62,31.89C1108.4,929.16,1087,942.05,1066.28,942.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1072.55,969.48a52.91,52.91,0,0,1-6.07-.35c-12.73-1.48-27.56-9.25-32-23.29l1-.33c4.31,13.58,18.73,21.1,31.11,22.54,16,1.86,34.06-4,50.86-16.37,11.07-8.17,20.81-18.31,30.22-28.11,3.12-3.24,6.34-6.6,9.57-9.84a370.82,370.82,0,0,1,46-39.14c10.81-7.77,22.58-14.91,35.48-14.91l1.3,0a28.26,28.26,0,0,1,20.58,10.75c3.68,4.82,5,10.35,3.8,15.59l-1.06-.25c1.15-4.91-.13-10.13-3.61-14.68A27.1,27.1,0,0,0,1240,860.8c-13.13-.48-25.09,6.76-36.1,14.68a368.65,368.65,0,0,0-45.88,39c-3.22,3.23-6.44,6.59-9.55,9.83-9.45,9.83-19.22,20-30.36,28.23C1103.18,963.6,1087.23,969.48,1072.55,969.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1085.4,985.91a32.45,32.45,0,0,1-14.85-3.43l.49-1c17.33,8.75,38.08-2.45,46.2-7.68,9.1-5.86,17.65-13,25.91-19.9,13.66-11.42,27.78-23.22,44.71-29.43,8.66-3.18,16.61-4.21,23.62-3.09,8.65,1.4,16,6.25,19.53,13l-1,.51c-3.42-6.44-10.43-11.08-18.74-12.42-6.81-1.1-14.59-.08-23.08,3-16.75,6.14-30.8,17.88-44.38,29.23-8.29,6.93-16.86,14.09-26,20C1110.44,979.5,1098.13,985.91,1085.4,985.91Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrationCard2);
export default __webpack_public_path__ + "static/media/migration_card_2.c0413866e0818612bce422c44ea30f97.svg";
export { ForwardRef as ReactComponent };